import $ from 'jquery';

const Snappy = {

  init: function() {
    document.addEventListener('DOMContentLoaded', this.onDOMLoaded.bind(this));
    $(window).on('content:updated', this.renderComponents.bind(this));
  },

  onDOMLoaded: function(event) {
    this.renderComponents();
  },

  renderComponents: function() {
    for (let key in this.Component) {
      let elements = document.querySelectorAll(`[data-${this.Component[key].tagName}]:not([data-defer-snappy])`);
      elements = Array.prototype.slice.call(elements);

      elements.forEach(function(element) {
        let isInited = element.getAttribute( 'data-'+this.Component[key].tagName + '-inited' );

        if ( typeof isInited === 'string' ) {
            return;
        }

        let component = new this.Component[key](element);
        element.component = component;
        element.setAttribute( 'data-' + this.Component[key].tagName + '-inited', '' );
        component.render();
      }.bind(this));
    }
  },

  Component: {},

  BaseComponent: class {
    constructor(element) {
      this.element = element;

      if ($) {
        this.$element = $(element);
        this.$window = $(window);
        this.$body = $('body');
      }
    }
  }

};

export default Snappy;



// WEBPACK FOOTER //
// ./libs/snappy/snappy.js